/*!
 * italiansecret_frequency_buttons.js
 * Handles subscription frequency selection via button toggles.
 * - Saves the selected frequency to sessionStorage.
 * - Updates the Appstle drawer frequency dropdown accordingly.
 */

// Top-level robust label mapping
const labelToDropdownLabel = {
  "One time": "One Time Purchase",
  "Every 1 week": "every week",
  "Every 2 weeks": "every 2 week",
  "Every 3 weeks": "every 3 week",
  "Every 4 weeks": "every 4 week",
};

// Fire real mouse events for HeadlessUI/Appstle compatibility
function simulateRealClick(element) {
  if (!element) return;
  ["mousedown", "mouseup", "click"].forEach((eventType) => {
    element.dispatchEvent(
      new MouseEvent(eventType, {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  });
}

function updateDrawerDropdown(labelOrValue, retries = 10) {
  const dropdownBtn = document.querySelector(".as-plan-select-btn");
  if (!dropdownBtn) {
    if (retries > 0)
      setTimeout(() => updateDrawerDropdown(labelOrValue, retries - 1), 300);
    return;
  }

  // Try both label and value for compatibility
  let appstleLabel = labelToDropdownLabel[labelOrValue] || labelOrValue;
  // Special case: try to reverse-map if sessionStorage has value not label
  if (!Object.values(labelToDropdownLabel).includes(appstleLabel)) {
    // Try to find the key by value
    for (let key in labelToDropdownLabel) {
      if (labelToDropdownLabel[key] === labelOrValue) {
        appstleLabel = labelToDropdownLabel[key];
        break;
      }
    }
  }

  const listboxId = dropdownBtn.getAttribute("aria-controls");
  const isOpen = dropdownBtn.getAttribute("aria-expanded") === "true";

  if (!isOpen) {
    simulateRealClick(dropdownBtn);
    setTimeout(() => updateDrawerDropdown(labelOrValue, retries - 1), 200);
    return;
  }

  const optionsList = document.getElementById(listboxId);
  if (!optionsList) {
    if (retries > 0)
      setTimeout(() => updateDrawerDropdown(labelOrValue, retries - 1), 200);
    return;
  }
  const options = optionsList.querySelectorAll('li, [role="option"]');
  if (!options.length) {
    if (retries > 0)
      setTimeout(() => updateDrawerDropdown(labelOrValue, retries - 1), 200);
    return;
  }

  let found = false;
  options.forEach((opt) => {
    if (opt.textContent.trim().toLowerCase() === appstleLabel.toLowerCase()) {
      simulateRealClick(opt);
      found = true;
    }
  });

  if (!found && retries > 0) {
    setTimeout(() => updateDrawerDropdown(labelOrValue, retries - 1), 200);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const frequencyOptions = [
    { label: "One time", value: "One time" },
    { label: "Every 1 week", value: "every 1 week" },
    { label: "Every 2 weeks", value: "every 2 weeks" },
    { label: "Every 3 weeks", value: "every 3 weeks" },
    { label: "Every 4 weeks", value: "every 4 weeks" },
  ];

  const container = document.querySelector(
    "#italiansecret-frequency-buttons div"
  );
  if (!container) return;
  container.innerHTML = "";

  const sessionKey = "selectedFrequency";
  const saved = sessionStorage.getItem(sessionKey);

  frequencyOptions.forEach((opt) => {
    const btn = document.createElement("button");
    btn.classList.add("frequency-button");
    btn.textContent = opt.label;
    btn.dataset.value = opt.value;

    if (saved === opt.value) {
      btn.classList.add("selected");
    }

    btn.addEventListener("click", function () {
      sessionStorage.setItem(sessionKey, opt.value);

      document.querySelectorAll(".frequency-button").forEach((b) => {
        b.classList.remove("selected");
      });

      btn.classList.add("selected");
      updateDrawerDropdown(opt.label);
    });

    container.appendChild(btn);
  });

  // Observe when the Appstle drawer renders and sync frequency if user had selected one before
  const observer = new MutationObserver(() => {
    const value = sessionStorage.getItem(sessionKey);
    if (value) updateDrawerDropdown(value); // handles both label and value!
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
